var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLighting = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-lighting-1827749",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    className: "st0",
    d: "M25.4,70.4l14.1,7.5L9.6,108.9L61,75.8l-15.3-6.6L80,38.1l0.4-0.4l-15.3-6.2L99.5,0L42.3,31.5 l16.6,8.3L25.4,70.4z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLighting, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lighting.db481f9e.svg";
export { ForwardRef as ReactComponent };